<template>
  <div class="travelIntroduction" id="travelIntroduction">
    <div class="container">
      <div class="title-top">
        <div class="title">
          <div class="one">{{message.styleTitle}}</div>
          <div class="describe">{{message.styleDescribe}}</div>
        </div>
        <div class="button-right" @click="toMore">
          <span>
            更多
            <i class="fa fa-plus" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="list">
        <div
          class="item"
          v-for="(item,index) in message.linePageList['0'].linePage"
          :key="index"
          @click="toDetail(item.id)"
        >
          <!-- <img :src="item.linePictureUrl" class="left-img" /> -->
          <div class="info-item">
            <div class="trans-img">
              <img :src="item.linePictureUrl" class="left-img" />
            </div>
            <div class="info-content">
              <div class="info-one">{{item.lineTitile}}</div>
              <div class="info-two">{{item.lineAbstract}}</div>
              <div class="bottom-info">
                <div>
                  <!-- <span class="icon-one">
                    <i class="fa fa-eye" aria-hidden="true"></i> 1265
                  </span>-->
                  <span class="icon-two">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    {{fomateDate(item.date)}}
                  </span>
                  <span class="icon-three" :class="colorClass(item.signUpStatus)">{{item.signUpStatus}}</span>
                </div>
                <span class="more">
                  {{ item.price ? `￥${item.price}` : '价格待定' }}
                  <!-- <i class="fa fa-arrow-right" aria-hidden="true"></i> -->
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- aboutUs end -->
</template>

<script>
import axios from "axios";
import { fomateDate } from "@/util/util";

export default {
  name: "travelIntroduction",
  data() {
    return {};
  },
  props: {
    message: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  computed: {
    nav() {
      return this.$route.params.id;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
    colorClass(status){
      return function(status){
        switch (status) {
          case '报名中':
            return 'green'
            break;
          case '已成行':
            return 'orange'
            break;
          case '已满员':
            return 'red'
            break;
        }
      }
    }
  },
  mounted() {},
  methods: {
    fomateDate,
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        query: { id: id }
      });
    },
    toMore() {
      this.$router.push({
        path: `/searchActivity`,
        query: {
          id: this.message.styleId,
          title: this.message.styleTitle
        }
      });
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  background: #fff;
  text-align: left;
  margin-bottom: 20px;
}
.title-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 小标题 */
.title {
  margin: 20px 0;
}
.one {
  color: #007741;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
}
.describe {
  border-top: 1px solid #cccccc;
  padding: 10px 0;
  color: #676767;
  font-size: 14px;
  width: 300px;
}
.button-right {
  width: 80px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  border: 1px solid #cccccc;
  border-radius: 8px;
  cursor: pointer;
}
.item {
  position: relative;
  width: 100%;
  height: 280px;
  margin-bottom: 20px;
}
.item:hover .left-img{
    transform: scale(1.2);

}
.trans-img {
  width: 50%;
  height: 100%;
  overflow: hidden;
  margin-right: 30px;
}
.left-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .left-img:hover {
  transform: scale(1.2);
} */
.info-item {
  cursor: pointer;
  position: absolute;
  right: 0;
  /* top: 20%; */
  /* transform: translateY(-50%); */
  /* width: 68%; */
  width: 100%;
  height: 280px;
  box-shadow: 0px 0px 10px #aaaaaa;
  z-index: 30;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 30px;
  display: flex;
  
}
.info-content {
  position: relative;
  width: 100%;
  height: 100%;
}
.info-one {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}
.info-two {
  line-height: 26px;
  color: #b0b0b0;
}
.bottom-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0px;
}
.icon-one {
  color: #b0b0b0;
  margin-right: 10px;
}
.icon-two {
  color: #b0b0b0;
}
.icon-three {
  margin-left: 20px;
  background: #007640;
  color: #fff;
  /* font-size: 14px; */
  padding: 4px 12px;
  border-radius: 12px;
  cursor: pointer;
}
.more {
  color: #f07621;
}
.green {
  background: #007640;
}
.orange {
  background: #ff6c00;
}
.red {
  background: rgb(211, 23, 23);
}
</style>



// WEBPACK FOOTER //
// src/components/home/travelIntroduction.vue